<div class="lookup-container">
  <input
    type="text"
    class="lookup"
    (keyup)="lookupChange()"
    [value]="searchTermState()"
    [class.searching]="isSearching()"
    (blur)="onBlur($event)"
    #lookup
  />
  <div class="spinner" *ngIf="isSearching()"></div>
  <div class="lookup-results" *ngIf="apiResponse() as apiResponse">
    <li *ngFor="let uni of apiResponse" (click)="selectUni(uni)">
      {{ uni.name }}
    </li>
    <p *ngIf="!apiResponse.length">
      {{ noUnisFoundMessage }} '{{ searchTermState() }}'
    </p>
  </div>

  <div class="error-block">
    <app-error-block *ngIf="lookupError()">
      There was an error searching for your college&#47;university.
    </app-error-block>
  </div>

  <p class="add-links">
    <a (click)="notAtUni()">I'm not at university</a>
    <a *ngIf="apiResponse()" (click)="doAddUni()">
      I can't see my college/university in the list
    </a>
  </p>
</div>
